module.exports = __webpack_public_path__ + "fonts/edex-icons.da654a9c.eot";